module.exports = __webpack_public_path__ + "static/media/toolkit.31c1aa17.jpg";